import {useQuery} from 'react-query';

import {getAllNotifications} from '.';

const useGetAllNotifications = () => {
  const {data, isLoading,refetch} = useQuery(
    ['get-all-notifications'],
    getAllNotifications,
  );

  return {notifications: data, isLoading,refetch};
};

export default useGetAllNotifications;
